import axios from '../_helpers/axios';

export const monitor_vehicleService = {
    get_data,
};

async function get_data(data) {
  return new Promise((resolve, reject) => {
    axios.post('monitor_vehicles',data)
    .then(resp => {
      if(resp.data && resp.data.data){
        resolve(resp.data.data)
      }
    }).catch(function(error){
      if (error.response && error.response.data && error.response.data.error) {
        reject(error.response.data.error.error_message)
        return
      }
      reject(error)
    })
  })
}
